import fetchExpresso from 'utility/fetchExpresso';

import type { ReportView, ReportViewConfig } from './reportViewTypes';

export type ForkReportViewInput = {
    name?: string;
    config?: ReportViewConfig;
};

export async function forkReportView(
    eventId: number,
    viewId: number,
    input: ForkReportViewInput = {},
): Promise<ReportView> {
    const res = await fetchExpresso(`/apiv2/events/${eventId}/report-views/${viewId}/fork`, {
        method: 'POST',
        body: input,
    });

    if (!res.ok) {
        const error = (await res.json().catch(() => null)) as { message?: string } | null;
        throw new Error(error?.message || 'Failed to fork report view');
    }

    const data = (await res.json()) as { view: ReportView };
    return data.view;
}
